
import React, { useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import SearchInstances from '@/components/admin/SearchInstances';
import InstanceTable from '@/components/admin/InstanceTable';
import SuperAdminLayout from '@/components/superadmin/SuperAdminLayout';
import InstancesHeader from '@/components/superadmin/InstancesHeader';
import { useSuperAdminInstances } from '@/hooks/useSuperAdminInstances';
import { useNavigate } from 'react-router-dom';

const SuperAdminInstances = () => {
  const navigate = useNavigate();
  
  const {
    isLoading,
    user,
    searchQuery,
    setSearchQuery,
    filteredInstances,
    handleLogout,
    handleSuspendInstance,
  } = useSuperAdminInstances();

  const handleManageInstance = (instanceId: string) => {
    navigate(`/super-admin/instance/${instanceId}`);
  };

  const handleVisitInstance = (domain: string) => {
    window.open(`https://${domain}`, '_blank');
  };

  const handleManagePayments = (instanceId: string) => {
    navigate(`/super-admin/instance/${instanceId}/payments`);
  };

  return (
    <SuperAdminLayout
      isLoading={isLoading}
      onLogout={handleLogout}
      userRole={user?.role}
      activeTab="instances"
    >
      <div className="max-w-7xl mx-auto">
        <InstancesHeader 
          userRole={user?.role}
          showCreateButton={false}
        />
        
        <Card className="mb-8">
          <CardHeader>
            <CardTitle>Instance Management</CardTitle>
          </CardHeader>
          <CardContent>
            <SearchInstances 
              searchQuery={searchQuery} 
              setSearchQuery={setSearchQuery} 
            />
            
            {isLoading ? (
              <div className="flex justify-center items-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-blue"></div>
              </div>
            ) : (
              <InstanceTable 
                instances={filteredInstances}
                handleManageInstance={handleManageInstance}
                handleVisitInstance={handleVisitInstance}
                handleSuspendInstance={handleSuspendInstance}
                handleManagePayments={handleManagePayments}
              />
            )}
          </CardContent>
        </Card>
      </div>
    </SuperAdminLayout>
  );
};

export default SuperAdminInstances;
